module.exports = __webpack_public_path__ + "static/media/person.ef4836bc.svg";